import React, { useMemo } from "react";

import { Table } from "antd";

import { getColorForTestResult } from "../Components/ReportSpecs/helper";
import "./ReportsTableSpecTooltip.css";

export default function ReportsTableSpecTooltip({ testResults, loading }) {
  const parsedResults = useMemo(
    () => (testResults?.length ? getColorForTestResult(testResults) : []),
    [testResults],
  );

  const showSpecsColumn = parsedResults.some(({ specs }) => specs && specs !== "-");

  const columns = useMemo(() => {
    const cols = [
      {
        title: "Test",
        dataIndex: "test",
        key: "test",
        className: "ReportsTableSpecTooltip__TestCell",
        onHeaderCell: () => ({ className: "ReportsTableSpecTooltip__TestCell" }),
      },
    ];

    if (showSpecsColumn) {
      cols.push({
        title: "Specs",
        dataIndex: "specs",
        key: "specs",
        className: "ReportsTableSpecTooltip__SpecsCell",
        onHeaderCell: () => ({ className: "ReportsTableSpecTooltip__SpecsCell" }),
        render: (value) => value || "-",
      });
    }

    cols.push({
      title: "Results",
      dataIndex: "result",
      key: "result",
      className: "ReportsTableSpecTooltip__ResultsCell",
      onHeaderCell: () => ({ className: "ReportsTableSpecTooltip__ResultsCell" }),
      render: (value, record) => (
        <span
          className="ReportsTableSpecTooltip__ResultValue"
          style={{ color: typeof record.color === "string" ? record.color : record.color?.color }}
        >
          {value || "-"}
        </span>
      ),
    });

    return cols;
  }, [showSpecsColumn]);

  const dataSource = useMemo(
    () => parsedResults.map(({
      test, specs, result, color,
    }, index) => ({
      key: `${test}-${index}`,
      test,
      specs,
      result,
      color,
    })),
    [parsedResults],
  );

  if (loading) {
    return (
      <div className="ReportsTableSpecTooltip">
        <span className="ReportsTableSpecTooltip__Loading">Loading...</span>
      </div>
    );
  }

  if (!testResults?.length) {
    return (
      <div className="ReportsTableSpecTooltip">
        <span className="ReportsTableSpecTooltip__Empty">No test results available</span>
      </div>
    );
  }

  return (
    <div className={`ReportsTableSpecTooltip ${showSpecsColumn ? "" : "ReportsTableSpecTooltip--noSpecs"}`}>
      <div className="ReportsTableSpecTooltip__Scroll">
        <Table
          className="ReportsTableSpecTooltip__Table"
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          size="small"
          showHeader
          rowHoverable={false}
        />
      </div>
    </div>
  );
}
